import React from "react";
import {
  AlertTriangle,
  TrendingDown,
  FileText,
  ClipboardList,
  ShieldAlert,
  CheckCircle,
  Eye,
} from "lucide-react";

const stats = [
  {
    title: "High EMI Leads",
    value: "15%",
    count: "1,875 leads",
    note: "Leads with EMI >70% of income",
    type: "danger",
    icon: AlertTriangle,
  },
  {
    title: "Low Salary Leads",
    value: "18%",
    count: "2,250 leads",
    note: "Salary below ₹15k/month",
    type: "warning",
    icon: TrendingDown,
  },
  {
    title: "Repeat Applications",
    value: "8%",
    count: "1,000 leads",
    note: "Multiple applications in 30 days",
    type: "neutral",
    icon: FileText,
  },
  {
    title: "Incomplete Forms",
    value: "17%",
    count: "2,125 leads",
    note: "Forms with missing data",
    type: "primary",
    icon: ClipboardList,
  },
];

const progressData = [
  { label: "Overall Quality", value: 72 },
  { label: "Form Completion Rate", value: 83 },
  { label: "Document Quality", value: 68 },
  { label: "Financial Profile", value: 65 },
];

const alerts = [
  {
    title: "High Priority Risk",
    type: "danger",
    icon: ShieldAlert,
    points: [
      "Low Salary Leads (18%): High rejection probability",
      "Incomplete Forms (17%): Leads to delays",
      "High EMI Leads (15%): Default risk",
    ],
  },
  {
    title: "Positive Trend",
    type: "success",
    icon: CheckCircle,
    points: [
      "Incomplete Forms: Down 7%",
      "High EMI Leads: Down 5%",
      "Low Salary Leads: Down 3%",
    ],
  },
  {
    title: "Areas to Monitor",
    type: "warning",
    icon: Eye,
    points: [
      "Repeat Applications: Up 2%",
      "Monitor fraud attempts",
      "Consider cooling-off period",
    ],
  },
];

const RiskQuality = () => {
  return (
    <div className="risk-container">
      <div className="rq-stats">
        {stats.map((item, index) => {
          const Icon = item.icon;

          return (
            <div key={index} className={`rq-card ${item.type}`}>
              <div className="rq-card-header">
                <Icon size={18} /> <br />
                <span className="rq-card-title">{item.title}</span>
              </div>

              <div className="rq-card-value">{item.value}</div>
              <div className="rq-card-count">{item.count}</div>
              <div className="rq-card-note">{item.note}</div>
            </div>
          );
        })}
      </div>

      <div
        className="rq-alerts"
        style={{
          marginTop: "50px",
        }}
      >
        <h5 className="common-heading">Risk Analysis Summary</h5>

        {alerts.map((alert, i) => {
          const Icon = alert.icon;

          return (
            <div key={i} className={`rq-alert ${alert.type}`}>
              <div className="rq-alert-header">
                <Icon size={18} /> <br />
                <h4>{alert.title}</h4>
              </div>

              <ul>
                {alert.points.map((point, j) => (
                  <li key={j}>{point}</li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>

      <div
        className="rq-bottom"
        style={{
          marginTop: "50px",
        }}
      >
        <div className="rq-progress-card">
          <h5 className="common-heading">Lead Quality Score</h5>

          {progressData.map((item, index) => (
            <div key={index} className="rq-progress-item">
              <div className="rq-progress-label">
                <span>{item.label}</span>
                <span>{item.value}/100</span>
              </div>
              <div className="rq-progress-bar">
                <div
                  className="rq-progress-fill"
                  style={{ width: `${item.value}%` }}
                />
              </div>
            </div>
          ))}
        </div>

        <div className="rq-actions-card">
          <h5 className="common-heading">Recommendation Actions</h5>

          <div className="rq-action blue">1. Enhance Pre-qualification</div>
          <div className="rq-action green">2. Improve Form UX</div>
          <div className="rq-action red">3. Partner Training</div>
          <div className="rq-action purple">4. Fraud Detection</div>
        </div>
      </div>
    </div>
  );
};

export default RiskQuality;
